export class VatRate {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly rate: number,
    public readonly enabled: boolean,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {
  }

  static fromJson(json: any): VatRate {
    return new VatRate(
      String(json['id']),
      json['name'],
      json['rate'],
      json['enabled'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    )
  }
}